
<app-navigation class="pcoded-navbar" [ngClass]="{
    'navbar-collapsed': navCollapsed,
    'theme-horizontal': gradientConfig['layout'] === 'horizontal',
    'theme-compact': gradientConfig['layout'] === 'compact',
    'mob-open': navCollapsedMob
  }" (NavCollapsedMob)="navMobClick()" />

<app-nav-bar
    class="navbar pcoded-header navbar-expand-lg navbar-light"
    (NavCollapse)="navCollapsed = !navCollapsed"
    (NavCollapsedMob)="navMobClick()" />

<div class="pcoded-main-container">
    <div class="pcoded-wrapper"
        [ngClass]="{
            container: gradientConfig.layout === 'horizontal'
                && gradientConfig.subLayout === 'horizontal-2'
        }">
        <div class="pcoded-content">
            <div class="pcoded-inner-content">
                <div class="main-body">
                    <div class="page-wrapper">
                        <app-breadcrumb />
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="pc-menu-overlay"
        (click)="closeMenu()"
        (keydown)="handleKeyDown($event)"
        tabindex="0">
    </div>
</div>

<app-footer [ngClass]="{
    'navbar-collapsed': navCollapsed
  }" />

<app-configuration />

<!-- Smart Alerts popup -->
<app-smart-alert />
